export const getDaysOfWeekValue = ({ dayOfWeek }) =>
  dayOfWeek === '*' ? [] : dayOfWeek.split(',');
